<div class="input" [ngClass]="validationClass">
    <span *ngIf="name" class="input-name">{{name}}</span>
    <span *ngIf="required" class="required-red">*</span>
  <div style="position:relative">
    <img *ngIf="withImage" src="../../../../content/images/Magnifier.svg" class="input-image" [ngStyle]="name && {'top': '30px'}" (click)="imageClicked.emit(value)">
    <input name="autocomplete"
           matInput type="text"
           class="input-component"
           inputPattern
           inputTrim
           [inputTypePattern]="inputTypePattern"
           [ngModel]="value"
           [placeholder]="placeholder"
           [disabled]="!!disabled"
           [maxLength]="maxTextLength"
           [matAutocomplete]="auto"
           (ngModelChange)="onModelChanged($event)"
           (blur)="onSaveModel()"
           (focus)="onSaveState()"
           #inputAutoCompleteRef>
      <img *ngIf="showEye" src='../../../../content/images/eye.svg' (click)="showHideValue()" class="show-hidden-value">
    <div class="hider" *ngIf="hideValue && showEye && value">X</div>
  </div>
</div>

<mat-autocomplete tab-selected #auto="matAutocomplete" [displayWith]="autoCompleteDisplayFn" autoActiveFirstOption>
  <mat-option *ngFor="let option of autoCompleteValues"
              [value]="option"
              [disabled]="option.name==''"
              [innerHTML]="(option.valueHtml ? option.valueHtml : option.value) | safeHtml">
  </mat-option>
</mat-autocomplete>
